import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTE_DEFINITIONS } from '@/routes';


export type MonthSummaryDetailRecordType = 'HHEE' | 'Atrasos';

export interface UseMonthSummaryDetailNavigationResult {
  navigateToDetail: (recordType: MonthSummaryDetailRecordType) => void;
}

// Data hook for the "Resumen del mes" dashboard "Horas Extra" (ASIS-5396 / REXASIS-005)
// and "Atrasos" (ASIS-5397 / REXASIS-006) cards "Detalle" action. Redirects to
// "Resumen asistencia" preserving the company and cutoff already selected in the
// dashboard, and preselecting the record type of the originating card.
export function useMonthSummaryDetailNavigation(
  selectedCompanyId: string,
  selectedCutId: string,
): UseMonthSummaryDetailNavigationResult {
  const navigate = useNavigate();

  const navigateToDetail = useCallback((recordType: MonthSummaryDetailRecordType) => {
    void navigate(
      `${ROUTE_DEFINITIONS.RESUMEN_ASISTENCIA.path}?companyId=${selectedCompanyId}&monthlyCutId=${selectedCutId}&type=${recordType}`,
    );
  }, [navigate, selectedCompanyId, selectedCutId]);

  return { navigateToDetail };
}

export default useMonthSummaryDetailNavigation;
